import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTargetState } from "src/store/features/TargetOrders.slice";
import clsx from "clsx";
import { TargetOrderStyles } from "../../styles/TargetOrder.style";
import ErrorIcon from "@mui/icons-material/Error";
const TargetOrderFormCompletion = () => {
  const classes = TargetOrderStyles();
  const defaultSteps = [
    { id: "toggle", desc: "Toggle Buy Or Sell", complete: true },
    { id: "tokenInput", desc: "Select Token", complete: false },
    { id: "tokenValueInput", desc: "Enter Units", complete: false },
    { id: "currencyInput", desc: "Select Currency", complete: false },
    {
      id: "currencyValueInput",
      desc: "Enter Price",
      complete: false,
    },
  ];
  const [steps, setSteps] = useState(defaultSteps);
  const { formCompletion } = useTargetState();
  const theme = useTheme();
  useEffect(() => {
    const updatedSteps = steps.map((step) => {
      const formComplete = formCompletion[step.id];
      return {
        ...step,
        complete: formComplete !== undefined ? formComplete : step.complete,
      };
    });

    setSteps(updatedSteps);
  }, [formCompletion, setSteps]);

  return (
    <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center">
      <Box
        sx={{
          width: "80%",
          height: "184px",
          backgroundColor: theme.palette.primary.contrastText,
          borderRadius: "10px",
          margin: "24px 24px 0 24px",
          padding: "16px 16px 16px 16px",
        }}>
        <Stack direction={"row"} alignItems="center" sx={{ mb: "12px" }}>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 700,
              color: theme.palette.text.primary,
            }}>
            Complete required fields
          </Typography>
          <ErrorIcon sx={{ height: "15px", width: "15px", ml: "8px" }} />
        </Stack>
        {steps.map((item, ind) => {
          return (
            <Stack direction="row" key={ind} justifyContent="space-between" sx={{ mb: "8px" }}>
              <Typography
                className={clsx(classes.completionText, {
                  [classes.completionTextCompleted]: item.complete,
                })}>
                {item.desc}
              </Typography>
              {
                <CheckCircleIcon
                  id="target-order-completion-check"
                  data-testid={`target-order-completion-isChecked-${item.complete}`}
                  sx={{
                    height: "17px",
                    width: "17px",
                  }}
                  className={clsx(classes.completionText, {
                    [classes.completionTextCompleted]: item.complete,
                  })}
                />
              }
            </Stack>
          );
        })}
      </Box>
    </Grid>
  );
};

export default TargetOrderFormCompletion;
